/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_GenerateInputs */

const cs_tasks_protocol_generate = /** @type {(inputs: Tasks_Protocol_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat protokol`)
};

const en_tasks_protocol_generate = /** @type {(inputs: Tasks_Protocol_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate protocol`)
};

/**
* | output |
* | --- |
* | "Generate protocol" |
*
* @param {Tasks_Protocol_GenerateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_generate = /** @type {((inputs?: Tasks_Protocol_GenerateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_GenerateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_generate(inputs)
	return cs_tasks_protocol_generate(inputs)
});